import React, { Component } from 'react';
import Header from '../../Header'
import { buttons } from '../../../helpers/const'
import Very from '../../../helpers/request_wrapper'

class Succeeded extends React.Component {
  constructor(props) {
    super(props);
  }

  charge = () => {
    this.setState({ loading: true });
    Very.post(`/charges`, { resource_type: "Package", resource_id: this.props.package_id }).then(res => {
      window.location.replace(`/`)
    })
  };

  render() {
    let { currentUser } = this.props;
    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <Header
            buttonText={buttons.persona.text}
            buttonUrl={buttons.persona.url}
            currentUser={currentUser}
          />

          <div className="col-12 md-px3 mx-auto py-110 sm-py4" style={{ maxWidth: '1010px' }}>
            <h2 className="center title mb-30">Thank you, your payment was successful!</h2>
            <div className="mx-auto" style={{ maxWidth: '390px' }}>
              <div className="mb-10">
                <a 
                  className="btn btn--primary btn--primary btn--fs-13 btn--lh-28 col-12 mb-20 mx-auto"
                  style={{ width: '160px' }}
                  href="/"
                >
                  Back to Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Succeeded
